import React, { useContext } from 'react'
import { BarLineExecutionStyles } from './Style'
import { AssessmentExecutionTrackingContext } from './AssessmentExecutionTrackingContext'

const BarItem = (props) => {
    const { selectedTab } = useContext(AssessmentExecutionTrackingContext)
    const { test_taker_execution_count, test_taker_count } = props
    const assessment_execution_percentage = test_taker_count > 0 ? (test_taker_execution_count / test_taker_count) * 100 : 0

    return (
        <BarLineExecutionStyles executionPercentage={assessment_execution_percentage} isLearningCenter={!selectedTab}>
            <div className='assessment-execution-line' />
        </BarLineExecutionStyles>
    )
}

export default BarItem